export default {
  common: {
    esg: {
      category: 'Categoría',
      environment: 'Medioambiente',
      society: 'Social',
      governance: 'Gobernanza',
      other: 'Otros',
      comprehensive: 'Total',
      // basic: '',
    },
    btn: {
      cancel: 'Cancelar',
      add: 'Agregar',
      create: 'Crear',
      update: 'Actualizar',
      apply: 'Aplicar',
      close: 'Cerrar',
      create_new: 'Crear nuevo',
      edit: 'Editar',
      detail: 'Detalle',
      view_detail: 'Detalle',
      delete: 'Eliminar',
      change: 'Cambiar',
      confirm: 'Confirmar',
      clear: 'Restablece',
      download: 'Descargar',
      save: 'Guardar',
      register: 'Registrar',
      check_answer: 'Verificar respuesta',
      score_card_list: 'Lista de cuadro de mandos',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: 'Descarga masiva',
    },
    link: {
      delete: 'Eliminar',
      back: 'Volver',
    },
    sentence: {
      back_to_login: 'Volver al inicio de sesión',
      back_to_dashboard: 'Volver al Panel de control',
      not_applicable: 'No procede*',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: 'Cuestionario',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: 'Seleccione un cuestionario',
      target_year: 'Año',
      target_year_text: 'Seleccione año',
      target_company: 'Empresa',
      target_company_text: 'Seleccione una empresa',
      total: 'Todos: {total}',
    },
    label: {
      required: 'Requerido',
      optional: 'Opcional',
      year: 'Año',
    },
    form: {
      search_word: {
        label: 'Búsqueda de palabras sueltas',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: 'Fecha de emisión',
      evaluation_expires_date: 'Fecha efectiva',
      answer_expires_date: 'Fecha límite',
      // last_updated_date: '',
    },
    error: {
      code_0005: 'Autenticación fallida. Por favor inicie sesión de nuevo',
      code_0007: 'Esta pregunta es obligatoria',
      code_5001: 'Página no encontrada.',
      code_0001: 'El último cuestionario ya ha sido enviado',
      code_0002: 'Fallo de actualización porque los últimos datos se actualizaron desde otro dispositivo. Vuelva a cargar e intente actualizar de nuevo.',
      code_0003: 'Error al borrar el archivo. Por favor, elimine después de contestar al menos una pregunta.',
      code_0006: 'El usuario ya está registrado',
      code_0004: 'Este archivo excede el tamaño posible de carga. Tenga en cuenta que el tamaño no debe superar los 50 MB.',
      code_9999: 'Ha ocurrido un error inesperado',
    },
    evaluation: {
      title: 'Solicitar evaluación',
      dashboard: 'Panel de control',
      analysis: 'Análisis',
      list: 'Lista de empresas',
    },
    dashboard: {
      title: 'Panel de control',
    },
    upload: {
      title: 'Cuestionario',
      common: 'Común',
    },
    scorecard: {
      title: 'Tarjeta de puntaje',
      list: 'Lista',
      detail: 'Detalle',
      scorecard_detail: 'Detalles del cuadro de mandos',
      answer_preview: 'Vista previa de la respuesta',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: 'Plan de mejora',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: 'Análisis extra',
    },
    settings: {
      title: 'Configuración',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: 'Preguntas frecuentes',
    },
    logout: {
      title: 'Cerrar sesión',
    },
    industry: {
      type_1: 'Agricultura, silvicultura y pesca',
      type_2: 'Minería, canteras y extracción de grava',
      type_3: 'Industria de la construcción (incluida la construcción de instalaciones)',
      type_4: 'Industria manufacturera (hierro, acero, metales no férreos, productos metálicos)',
      type_5: 'Industria manufacturera (maquinaria, equipos, electrónica, etc.)',
      type_6: 'Industria manufacturera (alimentación, bebidas, tabaco, etc.)',
      type_7: 'Industria manufacturera (pasta, papel, productos de papel)',
      type_8: 'Industria manufacturera (madera, transformación de productos de madera)',
      type_9: 'Industria manufacturera (industria química, incluidos los productos farmacéuticos y la industria textil)',
      type_10: 'Industria manufacturera (petróleo, carbón, caucho, plástico, etc.)',
      type_11: 'Industria manufacturera (industria gráfica)',
      type_12: 'Industria manufacturera (otros)',
      type_13: 'Suministro de electricidad, gas y calor',
      type_14: 'Telecomunicaciones',
      type_15: 'Industria del transporte y almacenamiento',
      type_16: 'Industria mayorista y minorista',
      type_17: 'Industria financiera y de seguros',
      type_18: 'Industria inmobiliaria',
      type_19: 'Escuelas (incluidos jardines de infancia y guarderías)',
      type_20: 'Industria de hostelería y alimentación',
      type_21: 'Industria de servicios relacionados con la vida (lavandería, peluquería, belleza, baños, etc.)',
      type_22: 'Industria médica y asistencial',
      type_23: 'Industria de eliminación y reciclaje de residuos',
      type_24: 'Industria de mantenimiento de automóviles',
      type_25: 'Gobiernos locales, autoridades, etc.',
      type_26: 'Otro',
    },
    scale: {
      a: '1〜29 persona(s)',
      b: '30〜99 personas',
      c: '100〜499 personas',
      d: '500〜999 personas',
      e: '1000〜4999 personas',
      f: 'Más de 5000 personas',
    },
    sales_amount: {
      under_1million: '~1 millón USD',
      under_10million: '1~10 millones USD',
      under_100million: '10~100 millones USD',
      under_1billion: '100 millones~1000 millones USD',
      under_10billion: '1000 millones~10000 millones USD',
      over_10billion: '10000 millones~ USD',
      not_disclose: 'No deseo revelarlo',
    },
    progress: 'Progreso',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: 'Desglose',
    help: 'Ayuda',
    user_display_mode: {
      my_assessment: 'Mi evaluación',
      supply_chain_assessment: 'Evaluación de la cadena de suministro',
    },
    buyer: 'Empresas compradoras',
    supplier: 'Proveedor',
    error_page: {
      section_one: 'Página no encontrada',
      section_two: 'Compruebe la URL',
      to_dashboard: 'Volver al Panel de control',
    },
    priority: {
      good: 'Bien',
      high: 'algo',
      medium: 'medio',
      low: 'bajo',
    },
    priority_full_name: {
      high: 'Riesgo algo',
      medium: 'Riesgo medio',
      low: 'Riesgo bajo',
    },
    faq: {
      how_to_use_csv_head: 'Para abrir el archivo CSV descargado en Excel, siga las instrucciones a continuación.',
      how_to_use_csv_body_01: '1. Abrir un nuevo libro de Excel en blanco.',
      how_to_use_csv_body_02: '2. En la pestaña «Datos» haga clic en «Desde texto o CSV».',
      how_to_use_csv_body_03: '3. Seleccione un archivo CSV y haga clic en «Importar».',
      how_to_use_csv_body_04: '4. Confirmar que el archivo se ha importado correctamente.',
      how_to_use_csv_body_05: '5. Seleccionar «Cargar»',
      how_to_use_csv_note: '※ El procedimiento puede variar dependiendo del sistema operativo y de la versión de Microsoft Excel utilizada.',
    },
    answer_display_status: {
      unanswered: 'No iniciado',
      temporarily_saved: 'En progreso',
      submitted: 'Enviado',
      score_rated: 'Evaluado',
      ended: 'Cerrado',
    },
    all: 'Todo',
    count: {
      // question: '',
      company: ' Empresas',
      unit: 'elementos',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: 'Estado',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: 'Ingresar',
      half_digits: 'Dígitos medios',
    },
  },
};
